import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import _ from 'lodash';

const withModal = WrappedComponent => props => {
    const [isClosing, setIsClosing] = useState(false);

    const cancelledHandler = (_isHiding) => {
        setIsClosing(true);
    };

    const submittedHandler = (data) => {
        if (_.isFunction(props.submitted)) { props.submitted(data); }
    };

    useEffect(() => {
        if (isClosing && _.isFunction(props.cancelled)) { props.cancelled(); }
        if (isClosing && _.isFunction(props.modalCancelled)) { props.modalCancelled(); }
    }, [props, isClosing]);

    return (
        <Modal bsSize={props.size} dialogClassName={props.dialogClassName} show={props.show} onHide={cancelledHandler} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <WrappedComponent {...props}
                    modalClosing={isClosing}
                    modalCancelled={(data) => cancelledHandler(data)}
                    modalSubmitted={(data) => submittedHandler(data)} />
            </Modal.Body>            
        </Modal>
    );
}

export default withModal;
